import { Component, OnInit, Input } from '@angular/core';
import { ProductsService } from '../../../services/products.service';
import { AppSetting } from '../../../global/appsetting';
import { HeaderService } from '../../../services/header.service';
import { Product } from 'src/app/models/products/products';
@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit {
  productList: Array<Product> = [];
  activateMovingMenu = false;
  displayProductList = false;
  hideMenu = true;
  isFirstLoadMenu = true;
  scrollHeight = this.headerService.scrollHeight;
  @Input() menuItems;
  displayEscortWindow = false;
  constructor(public appsetting: AppSetting,
    public headerService: HeaderService,
    public productsService: ProductsService,) { }

  ngOnInit() {
    this.productsService.productList$.subscribe(products=>{
      this.productList = products;
    })
    let element = document.getElementsByClassName('online-content-cube-wrapper')[0];
    if (!element) {
      element = document.getElementsByClassName('online-content-cube-wrapper-home')[0];
    }
    if(element){
      element.addEventListener('click', () => {
        if (this.activateMovingMenu) {
          this.activateMovingMenu = false;
        }
      });
    }
    
  }

  toggelMenu() {
    if (this.hideMenu) {
      this.activateMovingMenu = !this.activateMovingMenu;
    }
    this.hideMenu = true;
    this.isFirstLoadMenu = false;
    this.disabledWebSiteAnimaion();
  }

  disabledWebSiteAnimaion() {
    if (this.activateMovingMenu || this.displayEscortWindow) {
      document.querySelector('.anim-to-disable')?.classList.add('disable-anim');
    } else {
      document.querySelector('.anim-to-disable')?.classList.remove('disable-anim');
    }
  }

  toggelEscort() {
    this.displayEscortWindow = !this.displayEscortWindow;
    this.disabledWebSiteAnimaion();
  }

  showProductList() {
    this.displayProductList = !this.displayProductList;
    this.hideMenu = false;
  }
}
